 import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

const BalanceSheetPage = () => {
  const navigate = useNavigate(); // Use useNavigate hook for navigation

 ///////////////////////////////////////////////////////////
   const userPermissionsJSON = localStorage.getItem('USER_PERMISSIONS2');
  const userPermissions = JSON.parse(userPermissionsJSON);
   function getActionsForPage(pageName) {
    const pagePermissions = userPermissions.find(permission => permission.resource === pageName);
    console.log('actionsForPage', pagePermissions);
    if (pagePermissions) {
      return pagePermissions.action;
    } else {
      navigate('/dashboard_1');
      return [];
    }
  }

  const pageName = 'BalanceSheet';
  const actionsForPage = getActionsForPage(pageName);

///////////////////////////////////



  const [data, setData] = useState({ assets: [], liabilities: [], equity: [], total_assets: 0, total_liabilities: 0, total_equity: 0 });

  useEffect(() => {
    axios.get("https://subk.education.com.ly/back/api/reports/balance-sheet")
      .then(res => setData(res.data))
      .catch(err => console.error(err));
  }, []);

const renderTable = (items) => {
  if (!Array.isArray(items)) return null; // تجنب الخطأ
  return (
    <table className="table table-bordered table-striped mb-4">
      <thead className="table-dark">
        <tr>
          <th>الحساب</th>
          <th>الرصيد</th>
        </tr>
      </thead>
      <tbody>
        {items.map((item, idx) => (
          <tr key={idx}>
            <td>{item.AccountName}</td>
            <td>{item.Balance}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};


  return (
    <div className="container mt-4" dir="rtl">
      <h2 className="mb-4">الميزانية العمومية</h2>

      <h4>الأصول</h4>
      {renderTable(data.assets)}
      <p><strong>إجمالي الأصول: {data.total_assets}</strong></p>

      <h4>الالتزامات</h4>
      {renderTable(data.liabilities)}
      <p><strong>إجمالي الالتزامات: {data.total_liabilities}</strong></p>

      <h4>رأس المال</h4>
      {renderTable(data.equity)}
      <p><strong>إجمالي رأس المال: {data.total_equity}</strong></p>
    </div>
  );
};

export default BalanceSheetPage;
